
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.022 8.656a16.774 16.774 0 007.322 7.322l2.445-2.445c.311-.31.744-.4 1.133-.277 1.245.41 2.578.633 3.967.633.611 0 1.111.5 1.111 1.111v3.889C20 19.5 19.5 20 18.889 20 8.456 20 0 11.544 0 1.111 0 .5.5 0 1.111 0H5c.611 0 1.111.5 1.111 1.111 0 1.389.222 2.722.633 3.967.123.389.034.822-.277 1.133L4.022 8.656z","fill":"#8E8E8E"}})])
          )
        }
      }
    